module.exports = __webpack_public_path__ + "img/date-range-calendar.42d8153d.svg";